import { useMemo } from 'react'
import { isNil, toString } from 'lodash'

import { PAGINATION } from '../../common/constants'

import { useLoggedInUser } from '../../account/hooks'

import useMenuCurationTasksListFilters from './use-menu-curation-tasks-list-filters'

const useMenuCurationTasksFetchParams = () => {
  const { settings: userSettings } = useLoggedInUser()

  const {
    isCurrentUserAssigned,
    isCurrentUserAllocated,
    currentPage = PAGINATION.DEFAULT_PAGE,
    menuAvailability,
    pageSize = userSettings?.pageSize || PAGINATION.DEFAULT_PAGE_SIZE,
    taskStatus,
    autoeatStatus,
    tags,
    searchText,
    assignedTierOneCurator,
    assignedCurator,
    assignedQa,
    assignedQc,
    assignedScrapingReviewerUser,
    languageIds,
    duplicate,
    backlog,
    curatorId,
    sortBy,
    qaId,
  } = useMenuCurationTasksListFilters()

  const { filters, sorters, pagination } = useMemo(
    () => ({
      filters: {
        taskStatus,
        menuAvailability,
        languageIds,
        autoeatStatus,
        tags,
        duplicate,
        backlog,
        isCurrentUserAssigned,
        isCurrentUserAllocated,
        searchText: !isNil(searchText) ? toString(searchText) : null,
        assignedTierOneCurator: !isNil(assignedTierOneCurator)
          ? toString(assignedTierOneCurator)
          : null,
        assignedCurator: !isNil(assignedCurator)
          ? toString(assignedCurator)
          : null,
        assignedQa: !isNil(assignedQa) ? toString(assignedQa) : null,
        assignedQc: !isNil(assignedQc) ? toString(assignedQc) : null,
        assignedScrapingReviewerUser: !isNil(assignedScrapingReviewerUser)
          ? toString(assignedScrapingReviewerUser)
          : null,
        curatorId,
        qaId,
      },
      sorters: {
        sortBy,
      },
      pagination: {
        pageSize,
        currentPage,
      },
    }),
    [
      taskStatus,
      menuAvailability,
      languageIds,
      autoeatStatus,
      tags,
      duplicate,
      backlog,
      isCurrentUserAssigned,
      isCurrentUserAllocated,
      searchText,
      assignedTierOneCurator,
      assignedCurator,
      assignedQa,
      assignedQc,
      assignedScrapingReviewerUser,
      curatorId,
      qaId,
      sortBy,
      pageSize,
      currentPage,
    ],
  )

  return { filters, sorters, pagination }
}

export default useMenuCurationTasksFetchParams
